import { render, staticRenderFns } from "./RegionDocuments.vue?vue&type=template&id=4b00378c&scoped=true"
import script from "./RegionDocuments.vue?vue&type=script&lang=ts"
export * from "./RegionDocuments.vue?vue&type=script&lang=ts"
import style0 from "./RegionDocuments.vue?vue&type=style&index=0&id=4b00378c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b00378c",
  null
  
)

export default component.exports